document.addEventListener("DOMContentLoaded", function () {
  const hero = document.querySelector(".collection-hero.dynamic-aspect");
  if (!hero) return;

  const img = hero.querySelector(".collection-hero__image--banner");
  if (!img) return;

  function applyAspect() {
    if (img.naturalWidth && img.naturalHeight) {
      let ratio = img.naturalWidth / img.naturalHeight;
      hero.style.aspectRatio = ratio;
    }
  }

  if (img.complete) {
    applyAspect();
  } else {
    img.onload = applyAspect;
  }
});